// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Poppins/Poppins-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Poppins/Poppins-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Poppins/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/Poppins/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/Poppins/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/Poppins/Poppins-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/Poppins/Poppins-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/Poppins/Poppins-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/fonts/Poppins/Poppins-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/fonts/Poppins/Poppins-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/fonts/Poppins/Poppins-SemiBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./assets/fonts/Poppins/Poppins-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./assets/fonts/Poppins/Poppins-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./assets/fonts/SpaceMono/SpaceMono-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Poppins */
@font-face {
  font-family: "Poppins-Thin";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: "Poppins-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: "Poppins-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: "Poppins-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

@font-face {
  font-family: "Poppins-SemiBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

@font-face {
  font-family: "Poppins-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

@font-face {
  font-family: "Poppins-Black";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

/* Poppins Italic */
@font-face {
  font-family: "Poppins-ThinItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

@font-face {
  font-family: "Poppins-LightItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

@font-face {
  font-family: "Poppins-Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

@font-face {
  font-family: "Poppins-MediumItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

@font-face {
  font-family: "Poppins-SemiBoldItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

@font-face {
  font-family: "Poppins-BoldItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

@font-face {
  font-family: "Poppins-BlackItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

@font-face {
  font-family: "SpaceMono-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

@media print {
    #no-print {
       display: none;
    }
}

/* These styles make the body full-height */
html,
body,
#root {
  height: 100dvh;
}

/* These styles disable body scrolling if you are using <ScrollView> */
body {
  font-family: "Poppins-Regular";
  overflow: hidden;
}

/* These styles make the root element full-height */
#root {
  display: flex;
}

input, textarea, select, div {
  &:focus,
  &:active {
    outline: none;
  }
}

a {
  text-decoration: none;
}

div[role="slider"] {
  cursor: grab;

  &:focus,
  &:active {
    cursor: grabbing;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,2BAA2B;EAC3B,4CAAmD;AACrD;;AAEA;EACE,4BAA4B;EAC5B,4CAAoD;AACtD;;AAEA;EACE,8BAA8B;EAC9B,4CAAsD;AACxD;;AAEA;EACE,6BAA6B;EAC7B,4CAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,4CAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,4CAAmD;AACrD;;AAEA;EACE,4BAA4B;EAC5B,4CAAoD;AACtD;;AAEA,mBAAmB;AACnB;EACE,iCAAiC;EACjC,4CAAyD;AAC3D;;AAEA;EACE,kCAAkC;EAClC,4CAA0D;AAC5D;;AAEA;EACE,6BAA6B;EAC7B,4CAAqD;AACvD;;AAEA;EACE,mCAAmC;EACnC,6CAA2D;AAC7D;;AAEA;EACE,qCAAqC;EACrC,6CAA6D;AAC/D;;AAEA;EACE,iCAAiC;EACjC,6CAAyD;AAC3D;;AAEA;EACE,kCAAkC;EAClC,6CAA0D;AAC5D;;AAEA;EACE,6BAA6B;EAC7B,6CAAuD;AACzD;;AAEA;IACI;OACG,aAAa;IAChB;AACJ;;AAEA,2CAA2C;AAC3C;;;EAGE,cAAc;AAChB;;AAEA,sEAAsE;AACtE;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,aAAa;AACf;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;;EAEZ;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["/* Poppins */\n@font-face {\n  font-family: \"Poppins-Thin\";\n  src: url(\"./assets/fonts/Poppins/Poppins-Thin.ttf\");\n}\n\n@font-face {\n  font-family: \"Poppins-Light\";\n  src: url(\"./assets/fonts/Poppins/Poppins-Light.ttf\");\n}\n\n@font-face {\n  font-family: \"Poppins-Regular\";\n  src: url(\"./assets/fonts/Poppins/Poppins-Regular.ttf\");\n}\n\n@font-face {\n  font-family: \"Poppins-Medium\";\n  src: url(\"./assets/fonts/Poppins/Poppins-Medium.ttf\");\n}\n\n@font-face {\n  font-family: \"Poppins-SemiBold\";\n  src: url(\"./assets/fonts/Poppins/Poppins-SemiBold.ttf\");\n}\n\n@font-face {\n  font-family: \"Poppins-Bold\";\n  src: url(\"./assets/fonts/Poppins/Poppins-Bold.ttf\");\n}\n\n@font-face {\n  font-family: \"Poppins-Black\";\n  src: url(\"./assets/fonts/Poppins/Poppins-Black.ttf\");\n}\n\n/* Poppins Italic */\n@font-face {\n  font-family: \"Poppins-ThinItalic\";\n  src: url(\"./assets/fonts/Poppins/Poppins-ThinItalic.ttf\");\n}\n\n@font-face {\n  font-family: \"Poppins-LightItalic\";\n  src: url(\"./assets/fonts/Poppins/Poppins-LightItalic.ttf\");\n}\n\n@font-face {\n  font-family: \"Poppins-Italic\";\n  src: url(\"./assets/fonts/Poppins/Poppins-Italic.ttf\");\n}\n\n@font-face {\n  font-family: \"Poppins-MediumItalic\";\n  src: url(\"./assets/fonts/Poppins/Poppins-MediumItalic.ttf\");\n}\n\n@font-face {\n  font-family: \"Poppins-SemiBoldItalic\";\n  src: url(\"./assets/fonts/Poppins/Poppins-SemiBoldItalic.ttf\");\n}\n\n@font-face {\n  font-family: \"Poppins-BoldItalic\";\n  src: url(\"./assets/fonts/Poppins/Poppins-BoldItalic.ttf\");\n}\n\n@font-face {\n  font-family: \"Poppins-BlackItalic\";\n  src: url(\"./assets/fonts/Poppins/Poppins-BlackItalic.ttf\");\n}\n\n@font-face {\n  font-family: \"SpaceMono-Bold\";\n  src: url(\"./assets/fonts/SpaceMono/SpaceMono-Bold.ttf\");\n}\n\n@media print {\n    #no-print {\n       display: none;\n    }\n}\n\n/* These styles make the body full-height */\nhtml,\nbody,\n#root {\n  height: 100dvh;\n}\n\n/* These styles disable body scrolling if you are using <ScrollView> */\nbody {\n  font-family: \"Poppins-Regular\";\n  overflow: hidden;\n}\n\n/* These styles make the root element full-height */\n#root {\n  display: flex;\n}\n\ninput, textarea, select, div {\n  &:focus,\n  &:active {\n    outline: none;\n  }\n}\n\na {\n  text-decoration: none;\n}\n\ndiv[role=\"slider\"] {\n  cursor: grab;\n\n  &:focus,\n  &:active {\n    cursor: grabbing;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
